import Vue from 'vue';
import { socketStream } from '../../model/socket-stream.js';
import { Asset } from '../../model/entities/asset.js';

export default {
	namespaced: true,
	state: {
		assets: {},
		contracts: {}
	},
	mutations: {
		setAssets(state, data) {
			if (!data) return;
			state.assets = data;
		},
		setContracts(state, data) {
			if (!data) return;
			state.contracts = data;
		},
		updateAssets(state, data) {
			if (!data) return;
			for (let name in data)
				state.assets[name] = data[name];
		},
		updateContracts(state, data) {
			if (!data) return;
			for (let name in data)
				state.contracts[name] = data[name];
		}
	},
	getters: {
		getAssets(state) {
			return state.assets;
		},
		getContracts(state) {
			return state.contracts;
		}
	},
	actions: {
		initialize(state, data) {
			// default values
			onSettingsReceived(state, makeDefaultSettings());

			let subMsg = JSON.stringify({
				ClassName: "TradingSpecsSubscription"
			});
			socketStream.addChannelHandler('TradingSpecs', 'tradestor', (setsJson) => {
				// [ 'snapshot', { "assets": { ... }, "contracts": { ... } } ]
				// or [ 'update', { "assets": { ... }, "contracts": { ... } } ]
				onSettingsReceived(state, setsJson);
			})
			socketStream.subscribeOnConnect(() => {
				socketStream.socket.send(subMsg);
			});
		}
	}
}

function onSettingsReceived(state, settings) {
	try {
		//console.log(settings);
		if (settings.length < 2) {
			return;
		}
		if (settings[0] === 'snapshot') {
			state.commit('setAssets', settings[1].assets);
			state.commit('setContracts', settings[1].contracts);
			return;
		}
		if (settings[0] === 'update') {
			state.commit('updateAssets', settings[1].assets);
			state.commit('updateContracts', settings[1].contracts);
			return;
		}
	} catch (e) {
		console.log(e);
	}
}

function makeDefaultSettings() {
	let sets = [
		'snapshot',
		{
			assets: {
				'USD': { title: 'US dollar'},
				'EUR': { title: ''},
				'JPY': { title: ''},
				'BTC': { title: 'Bitcoin'},
				'ETH': { title: ''},
				'ETC': { title: ''},
				'LTZ': { title: ''},
				'XMR': { title: ''},
				'RPL': { title: ''},
				'ZEC': { title: ''},
				'BCH': { title: ''}
			},
			contracts: {
				'BTCUSD': { groupName: 'Majors', baseAsset: 'BTC', counterAsset: 'USD', digits: 2, minVolume: 0.1, volumeStep: 0.1 },
				'EURUSD': { groupName: 'Forex', baseAsset: 'EUR', counterAsset: 'USD', digits: 5, minVolume: 1000, volumeStep: 1000 },
				'ETHUSD': { groupName: 'Majors', baseAsset: 'ETH', counterAsset: 'USD', digits: 3, minVolume: 0.1, volumeStep: 0.1 },
				'ETHBTC': { groupName: 'Majors', baseAsset: 'ETH', counterAsset: 'BTC', digits: 7, minVolume: 0.1, volumeStep: 0.1 },
				'USDJPY': { groupName: 'Forex', baseAsset: 'USD', counterAsset: 'JPY', digits: 3, minVolume: 1000, volumeStep: 1000 },
				'BTCUSDm': { groupName: 'Micro', baseAsset: 'BTC', counterAsset: 'USD', digits: 2, minVolume: 0.005, volumeStep: 0.005 },
				'ETCETH': { groupName: 'Altcoin', baseAsset: 'ETC', counterAsset: 'ETH', digits: 7, minVolume: 0.1, volumeStep: 0.1 },
				'LTZBTC': { groupName: 'Majors', baseAsset: 'LTZ', counterAsset: 'BTC', digits: 7, minVolume: 0.1, volumeStep: 0.1 },
				'XMRBTC': { groupName: 'Majors', baseAsset: 'XMR', counterAsset: 'BTC', digits: 7, minVolume: 0.1, volumeStep: 0.1 },
				'BCHBTC': { groupName: 'Altcoin', baseAsset: 'BCH', counterAsset: 'BTC', digits: 7, minVolume: 0.1, volumeStep: 0.1 },
				'ZECBTC': { groupName: 'Majors', baseAsset: 'ZEC', counterAsset: 'BTC', digits: 7, minVolume: 0.1, volumeStep: 0.1 }
			}
		}
	];
	return sets;
}